import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Volver',
  },
  metrics: {
    impressions: {
      label: 'Impresiones',
      description:
        'El número de veces que tu anuncio se mostró en los resultados de búsqueda de Google o en sitios asociados.',
    },
    clicks: {
      label: 'Clics',
      description: 'El número de veces que las personas hicieron clic en tu anuncio.',
    },
    budget_spent: {
      label: 'Presupuesto gastado',
      description: 'El importe total gastado en esta campaña.',
    },
    absolute_top_impression_percentage: {
      label: '% Impresiones parte superior absoluta',
      description:
        'El porcentaje de veces que tu anuncio apareció en la parte superior de los resultados de búsqueda de Google.',
    },
    phone_calls: {
      label: 'Llamadas',
      description: 'El número total de llamadas telefónicas recibidas desde tu anuncio.',
    },
    phone_impressions: {
      label: 'Impresiones de teléfono',
      description: 'El número de veces que tu número de teléfono se mostró en el anuncio.',
    },
    phone_through_rate: {
      label: 'Tasa de llamadas',
      description:
        'El porcentaje de impresiones de teléfono que resultaron en llamadas reales (Llamadas ÷ Impresiones de teléfono).',
    },
    directions: {
      label: 'Indicaciones',
      description: 'El número de veces que los usuarios hicieron clic para obtener indicaciones a tu negocio.',
    },
    daily_budget: {
      label: 'Presupuesto diario',
      description: 'El importe máximo establecido para gastar por día en esta campaña.',
    },
    status: {
      label: 'Estado',
      description: 'El estado de ejecución actual de tu campaña.',
    },
    ctr: {
      label: 'Tasa de clics',
      description: 'El porcentaje de vistas del anuncio que resultaron en clics (Clics ÷ Impresiones).',
    },
    average_cpc: {
      label: 'Coste medio por clic',
      description:
        'El importe medio que pagas cada vez que alguien hace clic en tu anuncio (Coste total ÷ Clics totales).',
    },
    conversions_from_interactions_rate: {
      label: 'Tasa de conversión',
      description: 'El porcentaje de interacciones con el anuncio que dieron lugar a una conversión.',
    },
    start_date: {
      label: 'Fecha de inicio',
      description: 'La fecha en que comenzó la campaña.',
    },
    sales_from_google_ads: {
      label: 'Ventas de Google Ads',
      description: 'El importe total generado a través de Google Ads.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'No especificado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Habilitado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Pausado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Desconocido',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Eliminado',
  },
  error_messages: {
    loading_failed: 'Error al cargar los detalles de la campaña. Por favor, inténtalo de nuevo.',
  },
};
